export const SWITCHER_TYPE_CUSTOMER = 'customer'
export const SWITCHER_TYPE_MANAGEMENT = 'management'
export const SWITCHER_TYPE_OWNER = 'owner'
